import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentCodesLookupService extends ApiAutoCompleteService {
  codeKey = 'PaymentCode';
  constructor(private service: CodeWrapperService) {
    super();
  }

  existingValues: string[] = [];

  paymentCodesEmpty$ = this.service
    .apiV1CodeCodetypePost(this.codeKey, {
      generalSearch: '', pageSize: 9999 
    })
    .pipe(shareReplay(1));

  mapRow(result) {
    return {
      value: result.id,
      label: `${result.code} - ${result.name}`,
      shortLabel: result.code,
      inactive: result.inactive
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    if (value === '') {
      return this.paymentCodesEmpty$.pipe(map((results) => results.data.map(this.mapRow).filter((x: any) => (!x.inactive || this.existingValues.includes(x.value)))));
    }
    return this.service
      .apiV1CodeCodetypePost(this.codeKey, {
        generalSearch: value, pageSize: 9999 
      })
      .pipe(map((results) => results.data.map(this.mapRow).filter((x: any) => (!x.inactive || this.existingValues.includes(x.value)))));
  }

  load(id: string): Observable<FieldSelectOption> {
    if (id !== '') {
      return this.service.apiV1CodeCodetypeIdGet(this.codeKey, id).pipe(map(this.mapRow));
    }
  }
}
